var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSidePanelIcon = function SvgSidePanelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 62,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 14.6,
    strokeWidth: 2,
    d: "M11.837 35.884 1 41.184 43.116 60.73l42.117-19.547-10.838-5.067"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C7DDFB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 14.6,
    strokeWidth: 2,
    d: "M11.837 25.48 1 30.78l42.116 19.546 42.117-19.547-10.838-5.067"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m15.04 27.062 14.038 6.516 14.038 6.515 14.04-6.516 14.038-6.515L29.078 7.515m-14.039 6.516 14.039-6.516L43.116 1l14.04 6.516 14.038 6.515-42.116 19.547m28.077 0L15.04 14.03m0 13.031L1 20.547l14.04-6.516m0 13.031L57.154 7.516"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m71.194 27.062 14.039-11.167-14.04-1.864z"
  })));
};
export default SvgSidePanelIcon;